import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import { Dropdown, Menu } from 'antd';
import { showReleaseNotes } from '../../redux/actions/releaseNotes';
import releaseNotesArray from './releaseNotesArray';
import { ReactComponent as ReleaseNotesIcon } from '../../img/default-svg/realeaseNotes.svg';
import './style.scss';
import { useLocation } from "react-router-dom";
import { AppConfig } from "../../config";
import releaseNotesAdmin from "./releaseNotesAdmin";

const ReleaseNotes = ({ showReleaseNotes, releaseVersion, releaseAdmin }) => {
  const [menu, setMenu] = useState([]);
  const { t, i18n } = useTranslation();
  const { pathname } = useLocation();

  const releases = pathname?.includes('/admin') ? releaseNotesAdmin(t) : releaseNotesArray(t);
  const currentRelease = pathname?.includes('/admin') ? releaseAdmin : releaseVersion;
  const isAdmin = pathname?.includes('/admin');

  useEffect(() => {
    setMenu(
      <Menu>
        {releases.map(release => {
          return (
            <Menu.Item key={release.version} onClick={() => showReleaseNotes(release)}>
              <div className="release-notes__item">
                <span className="release-notes__version">
                  {t('releaseNotes.version')} {release.version}
                </span>
                <span className="release-notes__date">
                  {t(release.month.toLowerCase())} {t(release.time.toLowerCase())}
                </span>
              </div>
            </Menu.Item>
          );
        })}
      </Menu>
    );
  }, [i18n.language]);

  return (
    <div
      className={cn('release-notes', {
        'release-notes__new': (isAdmin ? localStorage.getItem('cpayAdminLastVersion') : localStorage.getItem('cpayLastVersion')) !== currentRelease,
      })}
    >
      <Dropdown overlay={menu} trigger="click" placement="bottomCenter">
        <ReleaseNotesIcon />
      </Dropdown>
    </div>
  );
};

const mapStateToProps = state => ({
  releaseVersion: state.user.releaseVersion,
  releaseAdmin: state.user.releaseAdmin,
});

const mapDispatchToProps = dispatch => ({
  showReleaseNotes: showReleaseNotes(dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseNotes);
